import { SelectItem } from 'primeng/api';
import { StateProvince } from './../../../config/shared/state-province/state-province.model';
import { StateProvinceService } from './../../../config/shared/state-province/state-province.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'wl-state-selector-modern',
  templateUrl: './state-selector-modern.component.html',
  styleUrls: ['./state-selector-modern.component.less'],
  standalone: false
})
export class StateSelectorModernComponent implements OnInit {
  public statesAndProvinces: SelectItem[] = [];

  @Input() public displayAbbreviation = true;
  @Input()
  get selectedState() {
    return this.selectedStateValue;
  }
  set selectedState(value: string) {
    if (value !== this.selectedStateValue) {
      if (this.selectedState == null) {
        setTimeout(() => {
          this.selectedStateValue = value;
          this.selectedStateChange.emit(this.selectedStateValue);
          // if the value comes from editing and is not in the predefined list (custom value), add it after load
          this.ensureCustomValuePresent();
        });
      } else {
        this.selectedStateValue = value;
        this.selectedStateChange.emit(this.selectedStateValue);
        this.ensureCustomValuePresent();
      }
    }
  }
  @Output() selectedStateChange: EventEmitter<string> = new EventEmitter();
  @Input() public disabled = false;

  selectedStateValue: string;

  constructor(private _stateProvinceService: StateProvinceService) {}

  ngOnInit(): void {
    this._stateProvinceService.getUsStatesAndCanadianProvinces().then((data: StateProvince[]) => {
      this.statesAndProvinces = data.map<SelectItem>((state) => {
        return { label: state.Abbreviation, value: state.Abbreviation };
      });
      // ensure previously saved (possibly custom) value is displayed
      this.ensureCustomValuePresent();
    });
  }

  /**
   * If the selected value was manually typed and does not exist in the default options,
   * add it dynamically so the p-dropdown can render it when reopening the form.
   */
  private ensureCustomValuePresent(): void {
    if (!this.selectedStateValue) return;
    const exists = this.statesAndProvinces.some((i) => i.value === this.selectedStateValue);
    if (!exists) {
      this.statesAndProvinces = [...this.statesAndProvinces, { label: this.selectedStateValue, value: this.selectedStateValue }];
    }
  }
}
